import React from 'react'
import styled from 'styled-components'
import { useForm, ValidationError } from '@formspree/react';

const Contact = () => {
  const [state, handleSubmit] = useForm("mdorykkj");
  if (state.succeeded) {
      return <p style={{color:"black",backgroundColor:"rgba(255, 204, 0, 1)",textAlign:"center",padding:"10px 0"}}>Thank you! The message has been sent successfully!</p>;
  }

  return (
    <>
      <Wrapper>
        <div className="container">
            <div className="heading">
                <h1>Keep In Touch</h1>
            </div>
            <div className="contactForm">
           <div className="contactDetails">
               <div className="imageLogo">
                <img src="./Images/logo.png" alt="" width={130}/>
               </div>
               <div className="contact">
                <img src="./Images/location.png" alt="" width={30}/>
                <p>Okara, Pakistan</p>
               </div>
               <div className="contact">
                <img src="./Images/email.png" alt="" width={28}/>
                <p>arslann407@gmail.com</p>
               </div>
               <div className="contact">
                <img src="./Images/phone.png" alt="" width={30}/>
                <p>+92 303 938 878 7</p>
               </div>
               <div className="contact">
                <img src="./Images/facebook.png" alt="" width={30} className='icon'/>
                <img src="./Images/instagram.png" alt="" width={30} className='icon iconn'/>
                <img src="./Images/twitter.png" alt="" width={30} className='icon iconn'/>
               </div>
           </div>
           <div className="form" >
            <form onSubmit={handleSubmit}>
              <div className="name">
              <input type="text" name='name' placeholder='Enter Your Name' required/>
              <input type="email" name='email' placeholder='Enter Your Email' required/>
              <ValidationError 
              prefix="Email" 
              field="email"
              errors={state.errors}
      />
              </div>
              <div className="subject">
                <input type="text" name='subject' placeholder='Subject'/>
              </div>
              <div className="message">
                <textarea name='message' placeholder='Message'></textarea>
              </div>
              <div className="btn">
               <button type="submit">Submit</button>
              </div>
            </form>
           </div>
           </div>
        </div>
        <div className="line"></div>
      </Wrapper>
    </>
  )
}

export default Contact

const Wrapper = styled.section`
.container{
    width: 100%;
    height: auto;
    background-color: rgba(45, 46, 46, 1);
    padding-left: 5%;
    padding-right: 5%;
}
.heading{
    padding-top: 50px;
}
.heading h1{
font-size: 35px;
color: rgba(255, 204, 0, 1);
text-align: center;
}
.contactForm{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 70px 0;
}
.contact{
    display: flex;
    align-items: center;
    margin-top: 20px;
}
.contact p{
display: inline;
padding-left: 15px;
}
.icon{
  cursor: pointer;
  transition:0.5s;
}
.icon:hover{
  transform: scale(1.3);
}
.iconn{
  margin-left: 20px;
}
.form{
  padding-left: 4%;
  
}

.name input{
  width: 28vw;
  height: 55px;
  background: none;
  border: 2px solid rgba(255, 204, 0, 1);
  opacity: 80%;
  margin-right: 12px;
  border-radius: 7px;
  padding-left: 15px;
}
.subject{
  margin-top: 20px;
}
.subject input{
  width: 57vw;
  height: 55px;
  background: none;
  border: 2px solid rgba(255, 204, 0, 1);
  opacity: 80%;
  margin-right: 0.8vw;
  border-radius: 7px;
  padding-left: 15px;
}
.message{
  margin-top: 20px;
}
.message textarea{
  width: 57vw;
  height: 160px;
  background: none;
  border: 2px solid rgba(255, 204, 0, 1);
  opacity: 80%;
  margin-right: 15px;
  border-radius: 7px;
  padding-left: 15px;
  padding-top: 10px;
  resize: none;
}
.btn{
  margin-top: 15px;
}
.btn button{
  width: 57vw;
  height: 55px;
  background: none;
  border: 2px solid rgba(255, 204, 0, 1);
  margin-right: 15px;
  border-radius: 7px;
  padding-left: 15px;
  cursor: pointer;
  color: rgba(255, 204, 0, 1) ;
  transition: 0.5s;
}
.btn button:hover{
  background-color: rgba(255, 204, 0, 1);
  color: white;
}
.line{
  width: 100%;
  height: 1px;
  background-color:  rgba(67, 67, 67, 1);
}

@media (max-width: 900px) {
  .name{
    display: flex;
    flex-direction: column;
    
  }
  .name input{
    width: 57vw;
    margin-top: 20px;
  }
}

@media (max-width: 830px) {
  .name input{
    width: 52vw;
  }
  .subject input{
    width: 52vw;
  }
  .message textarea{
    width: 52vw;
  }
  .btn button{
    width: 52vw;
  }
}
@media (max-width: 734px) {
  .contact p{
    font-size: 16px;
  }
  .heading h1{
    font-size: 25px;
  }
  .name input{
    width: 47vw;
    font-size: 16px;
    height: 48px;
  }
  .subject input{
    width: 47vw;
    font-size: 16px;
    height: 48px;
  }
  .message textarea{
    width: 47vw;
  }
  .btn button{
    width: 47vw;
    font-size: 16px;
    height: 48px;
  }
}
@media (max-width: 646px) {
  .form{
    margin-top: 50px;
  }
  .name input{
    width: 90vw;
    font-size: 16px;
    height: 48px;
  }
  .subject{
  margin-top: 10px;
}
.name input{
  margin-top: 10px;
}
.message{
  margin-top: 10px;
}
  .subject input{
    width: 90vw;
    font-size: 16px;
    height: 48px;
  }
  .message textarea{
    width: 90vw;
  }
  .btn button{
    width: 90vw;
    font-size: 16px;
    height: 48px;
  }

  .contactForm{
    display: flex;
    flex-wrap: wrap;
   
  }
  .form{
  padding-left: 0;
}
}
`
